export const blackPrimary = "";
export const yellowMain = "#EC0E6E";
export const yellow300 = "#ff59a1";
export const yellow100 = "#ffadd1";
export const black500 = '#141414';
export const black400 = "#555555";
export const black300 = "#B1B1B1";
export const black200 = "#D7D7D7";
export const blackBackground = "#222222";
